module.exports = __webpack_public_path__ + "static/media/merriweather-italic-webfont.5568fe0d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-italic-webfont.woff
// module id = 292
// module chunks = 0